export default {
    url: 'https://3zwo0jrw5b.execute-api.ap-northeast-1.amazonaws.com/V1/'
}